import React, { Component } from "react";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import AntDSelectWrapper from "../../../../Components/CustomWrappers/AntDSelectWrapper";
import { QUERY } from "../../../../constants";

class FMEDetails extends Component {
  render() {
    const {
      handleChange,
      formRef,
      fmeData,
      handleSearch,
      onClear,
      isDisabled,
      is_AN13,
      source
    } = this.props;
    return (
      <div className="row form-box">
        <legend className="form-legend">Sales Manager Details</legend>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="fme"
            id="FME Code"
            required={
              is_AN13 !== undefined
                ? is_AN13
                : source === QUERY.msme
                ? true
                : false
            }
            disabled={isDisabled}
            label="AMNS Sales Manager Name (If Available)"
            message="Enter FME Name"
            placeholder="Enter FME Name"
            validators=""
            onChange={handleChange}
            handleSearch={handleSearch}
            options={fmeData}
            allowClear={true}
            onClear={onClear}
            primary_key_field="id"
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="fme_name"
            id="FME Email"
            required={false}
            // disabled={isDisabled}
            label="AMNS Sales Manager Email"
            message="Enter FME Email"
            placeholder="Enter FME Email"
            validators=""
            formRef={formRef}
            disabled={true}
          />
        </div>
      </div>
    );
  }
}

export default FMEDetails;
